export enum BusinessMachineGroup {
  LIGHT_MACHINES = 'LIGHT_MACHINES',
  PRODUCTION_MACHINES = 'PRODUCTION_MACHINES',
  INDUSTRIAL_MACHINES = 'INDUSTRIAL_MACHINES',
  MOBILE_MACHINES = 'MOBILE_MACHINES',
  FIXED_INSTALLATIONS = 'FIXED_INSTALLATIONS',
  HIGH_TECH_INSTALLATIONS = 'HIGH_TECH_INSTALLATIONS',
  ENERGY_INSTALLATION = 'ENERGY_INSTALLATION',
}

export const getBusinessMachineGroupLabel = (group: BusinessMachineGroup) => {
  switch (group) {
    case BusinessMachineGroup.LIGHT_MACHINES:
      return $localize`Machines légères`;
    case BusinessMachineGroup.PRODUCTION_MACHINES:
      return $localize`Machines de production`;
    case BusinessMachineGroup.INDUSTRIAL_MACHINES:
      return $localize`Machines industrielles`;
    case BusinessMachineGroup.MOBILE_MACHINES:
      return $localize`Machines mobiles`;
    case BusinessMachineGroup.FIXED_INSTALLATIONS:
      return $localize`Installations fixes`;
    case BusinessMachineGroup.HIGH_TECH_INSTALLATIONS:
      return $localize`Installations hautes technologies`;
    case BusinessMachineGroup.ENERGY_INSTALLATION:
      return $localize`Installations énergie`;
    default:
      return '';
  }
};
